import { ThemeOverride } from '@aloft/toolkit-sui/chakra';

import { TOAST_CLASS_NAME } from '../hooks/useToaster/constants';
import { avatarStyle } from './avatarStyles';

export const toolkitTheme: ThemeOverride = {
  components: {
    Avatar: avatarStyle,
  },
  styles: {
    global: {
      a: {
        textDecoration: 'none',
      },
      [`.${TOAST_CLASS_NAME} > div[role='status']`]: {
        marginRight: 0,
      },
    },
  },
};
